import React from 'react';
import { useIntl } from 'react-intl';
import RouterNavigationTabs from '@/components/organisms/RouterNavigationTabs';
import { useUserTabRoutes } from '@/hooks/routes/useUserTabRoutes';
import { Switch } from '@/components/atoms/Switch';
import { Button } from '@/components/atoms/Button/Button';
import Loader from '@/components/atoms/Loader';
import { computeText } from '@/locales/utils';
import useUserRestaurantsControlVM from './UserRestaurantsControl.viewmodel';
import {
    Container,
    RestaurantWrapper,
    RestaurantText,
    ButtonWrapper,
    EmptyMessage,
} from './UserRestaurantsControl.style';

const UserRestaurantsControl: React.FC = () => {
    const { tabRoutes } = useUserTabRoutes();
    const intl = useIntl();
    const {
        handleSave,
        restaurants,
        selectedRestaurantIds,
        handleToggle,
        isButtonDisabled,
        isButtonLoading,
        isLoading,
        hasPermission,
    } = useUserRestaurantsControlVM();

    if (!hasPermission) {
        return null;
    }

    if (isLoading) {
        return (
            <RouterNavigationTabs routes={tabRoutes}>
                <Loader />
            </RouterNavigationTabs>
        );
    }

    return (
        <RouterNavigationTabs routes={tabRoutes}>
            <Container>
                {restaurants.length === 0 ? (
                    <EmptyMessage>{computeText(intl, 'userRestaurants.noRestaurants')}</EmptyMessage>
                ) : (
                    restaurants.map((restaurant) => (
                        <RestaurantWrapper key={restaurant.restaurantId}>
                            <Switch
                                onChange={() => handleToggle(restaurant.restaurantId)}
                                value={selectedRestaurantIds.has(restaurant.restaurantId)}
                            />
                            <RestaurantText>{restaurant.name}</RestaurantText>
                        </RestaurantWrapper>
                    ))
                )}
                <ButtonWrapper>
                    <Button
                        disabled={isButtonDisabled}
                        isLoading={isButtonLoading}
                        fullWidth={false}
                        onClick={handleSave}
                    >
                        {computeText(intl, 'button.save')}
                    </Button>
                </ButtonWrapper>
            </Container>
        </RouterNavigationTabs>
    );
};

export default UserRestaurantsControl;
